module.exports = __webpack_public_path__ + "img/footLogos.7dda623f.png";